import React from 'react'
import { createRoot } from 'react-dom/client';
import App from './App'
import { ApiProvider } from '../api'

import 'bootstrap/dist/css/bootstrap.min.css'

// API configuration from environment variables
const API_URL = process.env.REACT_APP_API_URL || 'https://jean-test-api.herokuapp.com/';
const API_TOKEN = process.env.REACT_APP_API_TOKEN || '';

if (!API_TOKEN) {
  console.warn(
    'Warning: REACT_APP_API_TOKEN is not set. ' +
    'Please create a .env file with your API token. ' +
    'See .env.example for reference.'
  );
}

const domRoot = document.getElementById('root');
const root = createRoot(domRoot!);

root.render(
  <React.StrictMode>
    <ApiProvider
      url={API_URL}
      token={API_TOKEN}
    >
      <App />
    </ApiProvider>
  </React.StrictMode>
)
